import React from 'react';
import { useParams } from "react-router-dom";
import NavigationBar from '../../components/Navigationbar/Navigationbar';
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';

function FileSystem() {
    const { id, name, ipend } = useParams();

    return (
        <>
            <head><title>Nutzer Dateien || {name}</title></head>
            <div style={{
                width: "90.5%",
                position: "fixed",
                right: "0",
                top: "0",
                display: "flex",
                flexWrap: "wrap",
                backgroundColor: "#eeefef",
                height: "100vh",
                alignItems: "center",
                justifyContent: "center",
            }}>
                <div style={{
                    backgroundColor: "white",
                    height: "99%",
                    width: "99%",
                    borderRadius: "15px",
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 6px 24px 0px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden"
                }}>
                    <div style={{
                        backgroundColor: "#2b3043",
                        height: "5.5%",
                        width: "100%",
                        borderRadius: "15px 15px 0 0",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 1rem",
                        color: "white",
                        fontWeight: "500",
                        fontSize: "16px",
                    }}>
                        <DriveFileMoveOutlinedIcon fontSize="large" style={{ marginRight: "0.5rem" }} />
                        {
                            name && ipend === "vereinsuserdata" && (
                                <span>Vereinsdateien von: <strong>{name}</strong></span>
                            )
                        }
                    </div>

                    <div style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "row",
                        padding: "1rem",
                        backgroundColor: "#f9f9f9",
                        overflowY: "auto",
                    }}>
                        <div style={{ width: "25%", fontSize: "16px", color: "gray", paddingLeft: "1rem" }}>
                            <p><strong>|</strong> Dateiname</p>
                        </div>
                        <div style={{ width: "25%", fontSize: "16px", color: "gray", paddingLeft: "1rem" }}>
                            <p><strong>|</strong> Änderungsdatum</p>
                        </div>
                        <div style={{ width: "25%", fontSize: "16px", color: "gray", paddingLeft: "1rem" }}>
                            <p><strong>|</strong> Letzte Interaktion</p>
                        </div>
                        <div style={{ width: "25%", fontSize: "16px", color: "gray", paddingLeft: "1rem" }}>
                            <p><strong>|</strong> Bearbeiten</p>
                        </div>
                    </div>
                    <ul>


                      
                    </ul>
                </div>
            </div>
            <NavigationBar state={"verein"} back={true} />
        </>
    );
}

export default FileSystem;
